export const bluePeach = 
    {
        palette: {
            type: "light",
            primary: {
                main: '#4169E1'
            },
            secondary: {
                main: '#ffcba4'
            },
        },
        typography: {
            fontFamily: "'Source Sans Pro', sans-serif",
            h1: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h2: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h3: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h4: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h5: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h6: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
        },
    }

export const skyBlue = 
    {
        palette: {
            type: "light",
            primary: {
                main: '#89ABE3' //'#5F4B8B'
            },
            secondary: {
                main: '#FCF6F5'  //'#E69A8D'
            },
            text: {
                primary: '#5F779E',
            },
            background: {
                paper: '#FCF6F5'
            }
        },
        typography: {
            fontFamily: "'Source Sans Pro', sans-serif",
            h1: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h2: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h3: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h4: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h5: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
            h6: {
                fontFamily: "'Playfair Display', sans-serif",
                fontWeight: 400
            },
        },
    }